<template><div><h1>VUX V2.2.1Rc.8 released</h1>
<h2><a href="/en/components/datetime.html">Datetime</a></h2>
<ul><li>[enhance] now changing prop:format will trigger re-rendering</li>
</ul>
<h2><a href="/en/components/popup-radio.html">PopupRadio</a></h2>
<ul><li>[fix] fix label width</li>
</ul>
<h2><a href="/en/components/scroller.html">Scroller</a></h2>
<ul><li>[change] set prop:prevent-default to false by default</li>
</ul>
<h2><a href="/en/components/x-number.html">XNumber</a></h2>
<ul><li>[fix] fix cannot edit first number character when fillable</li>
</ul></div></template><script>
export default {
  head: {"title":"VUX V2.2.1Rc.8 released | VUX - Vue.js Mobile UI Component Framework","ignoreSuffixChar":"|"}
}
  </script>


// WEBPACK FOOTER //
// v2.2.1-rc.8-97.vue?eb5815f4